import { Camera, Network, Dumbbell, RotateCcw, type LucideIcon } from "lucide-react"

export interface LoopStep {
  step: string
  phase: string
  icon: LucideIcon
  title: string
  description: string
}

export const loopSteps: LoopStep[] = [
  {
    step: "01",
    phase: "录入",
    icon: Camera,
    title: "拍照就能记",
    description:
      "拍错题、拍整页试卷，OCR 自动识别并切分题目，不用手抄。",
  },
  {
    step: "02",
    phase: "洞察",
    icon: Network,
    title: "知道为什么错",
    description:
      "AI 结构化分析错因，把错题挂上网状知识图谱——看到的不只是这一题，而是它背后的薄弱点。",
  },
  {
    step: "03",
    phase: "训练",
    icon: Dumbbell,
    title: "针对薄弱点开练",
    description:
      "小智推荐今天该练什么，逐题即时反馈；连错时主动帮你调难度、理思路。",
  },
  {
    step: "04",
    phase: "复盘",
    icon: RotateCcw,
    title: "记住，不再忘",
    description:
      "每次训练都有报告，掌握度变化看得见；知识点自动排进知识闪卡，在你快忘的时候提醒你。",
  },
]
